import AddIcon from '@mui/icons-material/Add';
import { PresetServerError } from 'config/requests/presets';
import { PresetsItemsSectionRow } from 'pages/Presets/components/PresetsItemsSectionRow/PresetsItemsSectionRow';
import { usePresetsErrors } from 'pages/Presets/hooks/usePresetsErrors';
import { getEmptyPresetItem } from 'pages/Presets/utils/getEmptyPresetItem';
import { HttpError } from 'react-admin';
import { useFieldArray } from 'react-hook-form';
import { Alert } from 'shared/mui/Alert/Alert';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';

import { PresetsItemsSectionBoxStyled } from './PresetsItemsSection.styled';

const MAX_ITEMS = 5;

type Props = {
  name: string;
  direction: string;
  title?: string;
  error?: HttpError | PresetServerError | null;
};

export const PresetsItemsSection: React.FC<Props> = ({ name, direction, title, error }) => {
  const { fields, append, remove } = useFieldArray({ name });
  const isMax = fields.length >= MAX_ITEMS;

  usePresetsErrors(error);

  return (
    <PresetsItemsSectionBoxStyled>
      {title && (
        <Typography fontWeight={500} variant="body1">
          {title}
        </Typography>
      )}
      {fields.map((field, index) => (
        <PresetsItemsSectionRow index={index} key={field.id} name={name} onRemove={remove} />
      ))}
      {isMax && (
        <Alert severity="warning" sx={{ mb: '8px' }}>
          Достигнуто максимальное число пресетов
        </Alert>
      )}
      <Button
        color="primary"
        disabled={isMax}
        label="Добавить пресет"
        onClick={() => append(getEmptyPresetItem(direction))}
        startIcon={<AddIcon />}
        sx={{ alignSelf: 'flex-start' }}
        variant="outlined"
      />
    </PresetsItemsSectionBoxStyled>
  );
};
